import "core-js/modules/es.array.concat.js";
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import { SOCIAL_MEDIA_SHARE_LINKS } from '~/constants';
export default defineComponent({
  name: 'ShareProduct',
  components: {
    AzButton: AzButton,
    AzIcon: AzIcon
  },
  setup: function setup() {
    var isShareOptionsOpened = ref(false);
    var toggleShareOptions = function toggleShareOptions() {
      isShareOptionsOpened.value = !isShareOptionsOpened.value;
    };
    var closeShareOptions = function closeShareOptions() {
      isShareOptionsOpened.value = false;
    };
    var currentUrl = computed(function () {
      return window.location.href;
    });
    var shareOptions = [{
      icon: 'facebook',
      handler: function handler() {
        window.open("".concat(SOCIAL_MEDIA_SHARE_LINKS.FACEBOOK).concat(currentUrl.value));
      }
    }, {
      icon: 'pinterest',
      handler: function handler() {
        window.open("".concat(SOCIAL_MEDIA_SHARE_LINKS.PINTEREST).concat(currentUrl.value));
      }
    }, {
      icon: 'twitter',
      handler: function handler() {
        window.open("".concat(SOCIAL_MEDIA_SHARE_LINKS.TWITTER).concat(currentUrl.value));
      }
    }, {
      icon: 'linkedin',
      handler: function handler() {
        window.open("".concat(SOCIAL_MEDIA_SHARE_LINKS.LINKEDIN).concat(currentUrl.value));
      }
    }, {
      icon: 'email',
      handler: function handler() {
        window.open("mailto:?body=".concat(currentUrl.value));
      }
    }];
    onMounted(function () {
      document.addEventListener('click', closeShareOptions);
    });
    onBeforeUnmount(function () {
      document.removeEventListener('click', closeShareOptions);
    });
    return {
      isShareOptionsOpened: isShareOptionsOpened,
      toggleShareOptions: toggleShareOptions,
      closeShareOptions: closeShareOptions,
      shareOptions: shareOptions
    };
  }
});